import 'css-chunksrc/client/scenes/timeRecordsListingConfiguration/styles.scss';export default {
  "timeRecordsListingConfiguration": "_timeRecordsListingConfiguration_1bqbr_1",
  "main": "_main_1bqbr_8",
  "tabs": "_tabs_1bqbr_14",
  "tab": "_tab_1bqbr_14",
  "selectedTab": "_selectedTab_1bqbr_34",
  "label": "_label_1bqbr_41",
  "footer": "_footer_1bqbr_48",
  "button": "_button_1bqbr_63"
};